import gql from 'graphql-tag'
import { EnumFields } from '..'

export const PersonTypeFragment = gql`
  fragment PersonType on persons_person_type {
    ${EnumFields}
  }
`
